import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayUseVO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly value: RoomBrandOverlayUse) {
    JsonSchemaValidator.assert(RoomBrandOverlayUseVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayUse {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
